import { forwardRef } from 'react';
import cx from 'classnames';
import { createUseHtmlId } from '../../hooks/useHtmlId';
import { useTruncationTooltip } from '../../hooks/useTruncationTooltip';
import { useGetDirection } from '../../locale/useBidiFormatter';
import { renderInlineCssVars, useDesignTokens } from '../../theme';
import { setRef } from '../../util/ref-util';
import cn from './Link.css.json';
import './Link.css';
import { jsx as _jsx } from "react/jsx-runtime";
const useHtmlId = createUseHtmlId('link');
export const Link = /*#__PURE__*/forwardRef(function Link(props, ref) {
  const setTruncationRef = useTruncationTooltip({
    tooltip: props.title
  });
  const {
    children,
    dir,
    small,
    disabled,
    wrapText,
    className,
    style,
    tabIndex,
    decoration,
    href,
    onPress,
    maxLines,
    preventTruncationTooltip,
    testId,
    ariaLabelledBy,
    ...restProps
  } = props;
  const dt = useDesignTokens();
  const tokens = renderInlineCssVars({
    fg: disabled ? dt.tokens['color-action-text-standard-disabled'] : dt.tokens['color-action-link-normal'],
    'font-size-m': dt.tokens['font-size-body-text-m'],
    'font-size-s': dt.tokens['font-size-body-text-s'],
    'focus-outline': 'var(--focus-light-bg)',
    'focus-outline-offset': 'calc(-1 * var(--focus-width))'
  }, 'link');
  const direction = dir ?? useGetDirection(children);
  const textId = useHtmlId();
  return /*#__PURE__*/_jsx("a", {
    ...restProps,
    "aria-labelledby": ariaLabelledBy ? `${ariaLabelledBy} ${textId}` : undefined,
    "aria-disabled": !!disabled,
    "data-testid": testId,
    ref: element => {
      if ((wrapText === false || maxLines !== undefined) && !preventTruncationTooltip) {
        setTruncationRef(element);
      }
      setRef(ref, element);
    },
    className: cx(cn.link, className, wrapText === false ? cn.nowrap : maxLines !== undefined && cn.hasMaxLines, small && cn.small, disabled && cn.disabled, decoration === 'hover-only' && cn.decoration.hover),
    style: {
      ...tokens,
      ...style
    },
    href: href && !disabled ? href : undefined,
    tabIndex: tabIndex ?? 0,
    onClick: e => {
      if (onPress) e.preventDefault();
      if (disabled) return;
      onPress?.(e);
    },
    onKeyDown: e => {
      if (e.key === 'Enter') {
        if (disabled) return;
        if (href) {
          e.stopPropagation();
          return;
        }
        e.preventDefault();
        onPress?.(e);
      }
      props.onKeyDown?.(e);
    },
    children: /*#__PURE__*/_jsx("span", {
      className: cn.text,
      dir: direction,
      style: {
        WebkitLineClamp: wrapText !== false ? props.maxLines : undefined
      },
      id: textId,
      children: children
    })
  });
});
//# sourceMappingURL=Link.js.map